var map = {
	"./de/video-btn.png": "PUV9",
	"./en/video-btn.png": "AOdp",
	"./es/video-btn.png": "9J8i",
	"./fr/video-btn.png": "Ag7K",
	"./ja/video-btn.png": "wNX0",
	"./ko/video-btn.png": "+VVV",
	"./pt/video-btn.png": "9Njo",
	"./ru/video-btn.png": "Fge5",
	"./tc/video-btn.png": "OVjg",
	"./th/video-btn.png": "jzwd"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8eel";